import React from "react";
import { Text, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  title: {
    fontFamily: "Lato Bold",
    fontSize: 7,
    marginBottom: 3,
  },
});

const Title = ({ children }) => <Text style={styles.title}>{children}</Text>;

export default Title;
